module.exports = __webpack_public_path__ + "static/media/luoshan_mobile.a19db647.webp";